import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface LeftSidebarProps extends ComponentPropsWithoutRef<"aside"> {
  children: ReactNode;
  className?: string;
}

export const LeftSidebar = ({
  children,
  className,
  ...rest
}: LeftSidebarProps) => (
  <aside
    className={classNames(
      "relative z-50 flex h-full overflow-hidden [grid-area:left-sidebar]",
      className,
    )}
    data-testid="builder-ui-left-sidebar"
    {...rest}
  >
    {children}
  </aside>
);
